import React from 'react';

import clsx from 'clsx';

import { LegacyBox, LegacyText, Tooltip, makeStyles } from '@gogame/components';
import { DateRangeFormatter } from '@gogame/intl-ts';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '8px 16px',
    '&:hover': {
      background: theme.palette.action.hover,
    },
  },
}));
const AnnotationListItem = React.forwardRef(
  (
    {
      period,
      type = {},
      subType = {},
      applications = [],
      networks = [],
      clusters = [],
      platforms = [],
      affiliates = [],
      description = '',
      style,
      className,
    },
    ref
  ) => {
    const classes = useStyles();
    const str = [applications, networks, clusters, platforms, affiliates]
      .map((el) => {
        return el.map(({ name }) => name).join(', ');
      })
      .filter((v) => v)
      .join(' / ');

    return (
      <LegacyBox
        style={style}
        gutter={2}
        vertical={true}
        className={clsx(classes.root, className)}
        ref={ref}
      >
        <Tooltip
          arrow
          title={
            <span>
              <span
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  wordBreak: 'break-all',
                }}
              >
                {description}
              </span>
              <em>{str}</em>
            </span>
          }
          position={'bottom'}
          maxWidth={'592px'}
        >
          <div>
            <LegacyBox gutter={8} wrap={'wrap'}>
              <LegacyText variant={'caption'}>
                <DateRangeFormatter value={period} />
              </LegacyText>
              <LegacyText variant={'caption'}>-</LegacyText>
              <LegacyText variant={'caption'}>
                {type.name} : {subType.name}
              </LegacyText>
            </LegacyBox>
            <LegacyBox gutter={2} wrap={'wrap'}>
              <LegacyText variant={'caption'} intensity={200} ellipsis={true}>
                {str}
              </LegacyText>
            </LegacyBox>
          </div>
        </Tooltip>
      </LegacyBox>
    );
  }
);

export default AnnotationListItem;
